import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ReviewPageState} from './review-page.state';

export const selectPatientState = createFeatureSelector<ReviewPageState>('reviews');

export const selectPatientById = (id: string) =>
  createSelector(selectPatientState, (state) => state.reviews[id]);

export const selectProfile = createSelector(selectPatientState, (state) => state?.profile);